// to transformer product according to product thumbnail interface
const simplifiedTransformer = (product) => {
  const id = product?.id;
  const identifier = product?.identifier;
  const pricing = product?.pricing;
  const flags = product?.detail?.flags;
  const brandName = product?.detail?.brand?.name ? product?.detail?.brand?.name : product?.detail?.brand;
  let primaryImage;
  if (product?.imagery?.primaryImage) {
    primaryImage = product?.imagery?.primaryImage;
  } else if (product?.imagery?.additionalImageSource) {
    primaryImage = product?.imagery?.additionalImageSource[0];
  } else {
    primaryImage = product?.imagery?.images[0];
  }
  const minDetailProduct = {
    id, identifier, detail: { brand: { name: brandName }, flags }, pricing, imagery: { primaryImage },
  };
  if (product?.pricing?.price?.tieredPrice && product.pricing.price.tieredPrice.length > 1) {
    minDetailProduct.pricing.price.tieredPrice.splice(0, minDetailProduct.pricing.price.tieredPrice.length - 1);
    delete minDetailProduct.pricing.price.priceType;
  }
  return minDetailProduct;
};
export default simplifiedTransformer;
